import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserSettingsComplete } from 'node_js/models/business/user-settings-complete';
import { UserSettingsValidation } from 'node_js/models/business/user-settings-validation';
import { UserSettingsService } from 'src/app/services/user-settings.service';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'user-settings-inputs',
  templateUrl: './user-settings-inputs.component.html',
  styleUrls: ['./user-settings-inputs.component.scss'],
})
export class UserSettingsInputsComponent  implements OnInit {

  @Input() validationErrors:UserSettingsValidation;
  @Input() userSettingsComplete:UserSettingsComplete;
  @Input() showEmail: boolean = false;
  @Output() finishedOnMobile: EventEmitter<void> = new EventEmitter<void>();

  constructor(
    protected userSettingsService:UserSettingsService,
    protected languageService: LanguageService,
  ) { }

  ngOnInit() {

  }

}
